<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div>
        <h6 class="modal-title" i18n>Security Deposit</h6>
        <div class="sub-header" *ngIf="deposit">
          <span class="badge" [ngClass]="getStatusClass(deposit.status)">
            {{ getStatusDisplay(deposit.status) }}
          </span>
          <span class="dot" *ngIf="deposit.created"> • {{ deposit.created | epoch : 'MMM DD, YYYY • hh:mm A' }} </span>
        </div>
      </div>
      <a (click)="onClose()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>

    <ul class="nav top-navbar bg-white border-bottom">
      <li [class.active]="tab === 'deposit'">
        <a (click)="setTab('deposit')" i18n>Deposit</a>
      </li>
      <li [class.active]="tab === 'logs'">
        <a (click)="setTab('logs')" i18n>Logs</a>
      </li>
    </ul>

    <div class="modal-body">
      <ng-container [ngSwitch]="tab">
        <ng-container *ngSwitchCase="'deposit'">
          <div class="container-box p-0 mb-0">
            <div class="deposit-details" *ngIf="deposit">
              <section class="details-section">
                <h6 i18n>Summary</h6>
                <div class="detail-grid">
                  <div class="detail-item">
                    <div class="label" i18n>Amount</div>
                    <div class="value">
                      {{ deposit.amount | tokeetCurrency : getCurrencySymbol(deposit.currency) }}
                    </div>
                  </div>
                  <div class="detail-item">
                    <div class="label" i18n>Status</div>
                    <div class="value">
                      <span class="badge" [ngClass]="getStatusClass(deposit.status)">
                        {{ getStatusDisplay(deposit.status) }}
                      </span>
                    </div>
                  </div>
                  <div class="detail-item" *ngIf="authorizedTimestamp !== null">
                    <div class="label">{{ getStatusDisplay('authorized') }}</div>
                    <div class="value">
                      {{ authorizedTimestamp | epoch : 'MMM DD, YYYY hh:mm A' }}
                    </div>
                  </div>
                  <div class="detail-item" *ngIf="authorizationEndingTimestamp !== null">
                    <div class="label" i18n>Authorization Ending</div>
                    <div class="value">
                      {{ authorizationEndingTimestamp | epoch : 'MMM DD, YYYY hh:mm A' }}
                    </div>
                  </div>
                  <div class="detail-item" *ngIf="statusTimestamp !== null">
                    <div class="label">{{ getStatusDisplay(deposit.status) }}</div>
                    <div class="value">
                      {{ statusTimestamp | epoch : 'MMM DD, YYYY hh:mm A' }}
                    </div>
                  </div>
                  <div class="detail-item" *ngIf="deposit.rental_id">
                    <div class="label" i18n>Rental</div>
                    <div class="value">
                      <app-rental-name [rentalId]="deposit.rental_id"></app-rental-name>
                    </div>
                  </div>
                  <div class="detail-item">
                    <div class="label" i18n>Guest Name</div>
                    <div class="value guest-value">
                      <ng-container *ngIf="guestName; else noGuest">
                        <app-avatar [text]="guestName" [size]="24" class="mr-2" [circle]="false"></app-avatar>
                        {{ guestName }}
                      </ng-container>
                    </div>
                  </div>
                  <div class="detail-item">
                    <div class="label" i18n>Guest Arrive</div>
                    <div class="value">
                      <ng-container *ngIf="guestArriveEpoch !== null; else noDate">{{
                        guestArriveEpoch | epoch : 'date'
                      }}</ng-container>
                    </div>
                  </div>
                  <div class="detail-item">
                    <div class="label" i18n>Guest Depart</div>
                    <div class="value">
                      <ng-container *ngIf="guestDepartEpoch !== null; else noDate">{{
                        guestDepartEpoch | epoch : 'date'
                      }}</ng-container>
                    </div>
                  </div>
                  <div class="detail-item" *ngIf="deposit.channel">
                    <div class="label" i18n>Channel</div>
                    <div class="value">{{ deposit.channel }}</div>
                  </div>
                  <div class="detail-item">
                    <div class="label" i18n>Gateway</div>
                    <div class="value gateway-select">
                      <ng-container *ngIf="paymentGateways.length; else noGateways">
                        <mat-form-field2 class="mat-block">
                          <app-select
                            [items]="paymentGateways"
                            bindValue="pkey"
                            bindLabel="name"
                            [formControl]="gatewayControl"
                            [disabled]="!allowGatewayChange || isUpdatingGateway"
                            placeholder=""
                            i18n-placeholder
                          >
                            <ng-template selectLabel let-items="items">
                              <ng-container *ngFor="let item of items">
                                <div class="text-capitalize">{{ item?.name || (item?.service | titleCase) }}</div>
                              </ng-container>
                            </ng-template>
                            <ng-template selectItem let-item="item">
                              <div class="text-capitalize">{{ item.name || (item.service | titleCase) }}</div>
                            </ng-template>
                          </app-select>
                          <mat-error *ngIf="gatewayControl.touched && gatewayControl.hasError('required')">
                            <ng-container i18n>Gateway is required</ng-container>
                          </mat-error>
                        </mat-form-field2>
                      </ng-container>
                      <ng-template #noGateways>
                        <span class="text-muted" i18n>No payment gateways available.</span>
                      </ng-template>
                    </div>
                  </div>
                  <div class="detail-item" *ngIf="deposit.description">
                    <div class="label" i18n>Description</div>
                    <div class="value description">{{ deposit.description }}</div>
                  </div>
                  <div class="detail-item" *ngIf="deposit.created">
                    <div class="label" i18n>Created</div>
                    <div class="value">{{ deposit.created | epoch : 'MMM DD, YYYY hh:mm A' }}</div>
                  </div>
                </div>
              </section>
            </div>

            <div class="deposit-actions">
              <button
                matTooltip="View this security deposit as guest"
                type="button"
                class="btn btn-light"
                (click)="onViewAsGuest()"
              >
                <i class="fal fa-external-link"></i>
                <ng-container i18n>Preview</ng-container>
              </button>
              <button
                matTooltip="Send security deposit to guest"
                type="button"
                class="btn btn-secondary"
                *ngIf="canSendDeposit"
                [disabled]="isSending"
                (click)="onSendDeposit()"
              >
                <i class="fal fa-paper-plane"></i>
                {{ sendButtonLabel }}
              </button>
              <button
                matTooltip="Capture security deposit funds"
                type="button"
                class="btn btn-secondary"
                *ngIf="canCaptureDeposit"
                [disabled]="isCapturing"
                (click)="onCaptureDeposit()"
              >
                <i class="fal fa-check-circle"></i>
                <ng-container i18n>Capture</ng-container>
              </button>
              <button
                matTooltip="Refund security deposit funds"
                type="button"
                class="btn btn-secondary"
                *ngIf="canRefundDeposit"
                [disabled]="isRefunding"
                (click)="onRefundDeposit()"
              >
                <i class="fal fa-undo"></i>
                <ng-container i18n>Refund</ng-container>
              </button>
              <button
                matTooltip="Cancel security deposit"
                type="button"
                class="btn btn-secondary"
                *ngIf="canCancelDeposit"
                [disabled]="isCanceling"
                (click)="onCancelDeposit()"
              >
                <i class="fal fa-times"></i>
                <ng-container i18n>Cancel</ng-container>
              </button>
              <button type="button" class="btn btn-light" (click)="onClose()">
                <i class="far fa-times"></i>
                <ng-container i18n>Close</ng-container>
              </button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'logs'">
          <div class="container-box logs-container mb-0">
            <div *ngIf="isLogsLoading" class="logs-loading text-muted">
              <i class="far fa-spinner fa-spin mr-2"></i>
              <span i18n>Loading logs...</span>
            </div>
            <div *ngIf="!isLogsLoading && logsError" class="logs-error text-danger">
              {{ logsError }}
            </div>
            <div *ngIf="!isLogsLoading && !logsError && !logs.length" class="logs-placeholder">
              <img src="assets/images/empty_images/no-history.png" alt="No history" class="empty-image" />
              <h5 class="empty-title" i18n>No History Available</h5>
              <p class="empty-description text-muted mb-0" i18n>
                As you make changes or updates, the history of your actions will appear here for tracking and review.
              </p>
            </div>
            <ul *ngIf="!isLogsLoading && !logsError && logs.length" class="logs-list">
              <li *ngFor="let log of logs; trackBy: trackLog" class="log-item">
                <div class="log-avatar">
                  {{ getLogInitial(log) }}
                </div>
                <div class="log-content">
                  <div class="log-header">
                    <span class="log-title">{{ getLogTitle(log) | titlecase }}</span>
                    <span class="log-date">
                      {{ log.created | epoch : 'MMM DD - YYYY hh:mm A' }}
                    </span>
                  </div>
                  <div class="log-message">{{ log.message }}</div>
                </div>
              </li>
            </ul>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noGuest>
  <span class="text-muted">-</span>
</ng-template>

<ng-template #noDate>
  <span class="text-muted">-</span>
</ng-template>
